import blank from '@/components/blank'
import myFinancing from './myFinancing'
import nototalList from './nototalList'
import recharge from '../myProfile/recharge'
import withdraw from '../myProfile/withdraw'
export default {
  path: '/',
  component: blank,
  meta: {title: '保理管理'},
  children: [
    {
      meta: {title: '我的保理', keepAlive: true},
      path: 'myFinancing',
      component: blank,
      children: [
        {
          path:'/',
          name:'myFinancing',
          component:myFinancing,
          meta:{keepAlive:true}
        },
        {
          meta:{title:'我的保理详情'},
          path:'nototalList',
          component:nototalList,
          name:'nototalList'
        },
        {
          meta:{title:'充值'},
          path:'recharge',
          component:recharge
        },
        {
          meta:{title:'提现'},
          path:'withdraw',
          component:withdraw
        }
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/pages/financingManagement/route.js